import React from 'react';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import useFundsStateStore from '../common/funds-state-hook';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 66px;
`;

const Img = styled.img`
  width: 120px;
  height: 110px;
`;

const Text = styled.div`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightBold};
  font-size: 28px;
  line-height: 130%;
  margin-top: 8px;
`;

const SecondaryText = styled.div`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightRegular};
  font-size: 19px;
  line-height: 130%;
  text-align: center;
  margin-top: 8px;
`;

const Button = styled.button`
  border: none;
  border-radius: 4px;
  outline: none;
  height: 40px;
  width: 335px;
  text-transform: uppercase;
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  font-size: 16px;
  line-height: 120%;
  margin: 40px 0;
  color: ${props => dt(props).theme.primaryColor};
  background: rgba(193, 157, 63, 0.1);

  &:hover {
    background-color: rgba(193, 157, 63, 0.2);
  }
`;

export default function NoResults() {
  const resetFilters = useFundsStateStore(state => state.resetFilters);
  const searchNoResultsImageUrl = useFundsStateStore(state => state.searchNoResultsImageUrl);

  const resetSearch = e => {
    e && e.preventDefault();
    resetFilters && resetFilters();
  };

  return (
    <Container>
      <Img src={searchNoResultsImageUrl} />
      <Text>No results found</Text>
      <SecondaryText>
        Try adjusting your search to find what you’re looking for.
      </SecondaryText>
      <Button onClick={resetSearch}>Reset Search</Button>
    </Container>
  );
}
